import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

import { UPCOMING_TAB_WIDTH } from "./upcomingDays";

// A slim handle on the left edge of the products table's scrolling area, over
// the pinned spacer column, so it never covers the TODAY header. It shows the
// upcoming days ("Next N days") and hides them again ("Hide"). It pulses until
// it has been used once.
const UpcomingDaysTab = ({
  days,
  targetUnits,
  shown,
  pulse,
  left,
  onClick,
}) => {
  const Chevron = shown ? ChevronRightIcon : ChevronLeftIcon;
  return (
    <>
      <style>
        {`
          @keyframes upcomingDaysPulse {
            0% { box-shadow: 0 0 0 0 rgba(29, 78, 216, 0.45); }
            70% { box-shadow: 0 0 0 6px rgba(29, 78, 216, 0); }
            100% { box-shadow: 0 0 0 0 rgba(29, 78, 216, 0); }
          }
        `}
      </style>
      <Tooltip
        placement="right"
        title={
          shown
            ? `Hide the next ${days} days`
            : `Next ${days} days only have a daily target${
                targetUnits > 0
                  ? ` (${targetUnits.toLocaleString()} units)`
                  : ""
              }. Click to see them.`
        }
      >
        <Box
          component="button"
          type="button"
          onClick={onClick}
          aria-label={
            shown ? `Hide the next ${days} days` : `Show the next ${days} days`
          }
          aria-expanded={shown}
          sx={{
            position: "absolute",
            top: "4px",
            bottom: "16px",
            left: `${left + 1}px`,
            zIndex: 5,
            width: `${UPCOMING_TAB_WIDTH - 2}px`,
            padding: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "2px",
            border: "1px solid #bfdbfe",
            borderLeft: "none",
            borderRadius: "0 8px 8px 0",
            backgroundColor: "#eff6ff",
            color: "#1d4ed8",
            fontFamily: "Inter",
            fontSize: "10px",
            fontWeight: 600,
            cursor: "pointer",
            animation:
              pulse && !shown
                ? "upcomingDaysPulse 1.8s ease-out infinite"
                : "none",
            "&:hover": { backgroundColor: "#dbeafe" },
          }}
        >
          <Chevron sx={{ fontSize: "15px" }} />
          <span
            style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              whiteSpace: "nowrap",
              letterSpacing: "0.02em",
            }}
          >
            {shown ? "Hide" : `Next ${days} days`}
          </span>
        </Box>
      </Tooltip>
    </>
  );
};

UpcomingDaysTab.propTypes = {
  days: PropTypes.number.isRequired,
  targetUnits: PropTypes.number,
  shown: PropTypes.bool,
  pulse: PropTypes.bool,
  // Distance from the grid's left edge to the spacer column, in pixels.
  left: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default UpcomingDaysTab;
